import RichText from 'components/ui/ContentBlocks/RichText';
import { formatNumber } from 'utils/number';
import { useTranslation } from 'hooks/useTranslation';
import CV from './CV';
import type { DoctorProfileEntry } from '.';
import type { ILanguagesFields } from 'types/contentful/generated';

function getLanguages(langs: ILanguagesFields[]): string {
  return langs.map((item) => item.language).join(', ');
}

type Props = {
  entry: DoctorProfileEntry;
};

const About = ({ entry }: Props): JSX.Element => {
  const { title, firstName, lastName, introRich, staffTreatment } = entry;

  const { treatmentsPerformed, yearsOfExperience, languagesSpoken } =
    staffTreatment.items[0] || {};

  const { locale, t } = useTranslation();

  return (
    <div className="max-w-screen-xl mx-auto px-5 md:px-4 lg:grid md:grid-cols-3 mt-18">
      <div>
        <h2 className="adelle-bold-section-headline">
          {t('doctorProfile.about.about')} {title} {firstName} {lastName}
        </h2>
      </div>
      <div className="col-span-2 lg:pl-12">
        <div className="text-primary mb-6">
          <RichText fields={introRich} />
        </div>

        <div className="grid md:grid-cols-2">
          {treatmentsPerformed && (
            <div className="mb-6">
              <p className="text-navy font-bold text-2xl">
                {formatNumber(treatmentsPerformed || 0, locale)}
              </p>
              <p>{t('doctorProfile.about.treatmentsPerformed')}</p>
            </div>
          )}
          {yearsOfExperience && (
            <div className="mb-6">
              <p className="text-navy font-bold text-2xl">
                {new Date().getFullYear() - yearsOfExperience}
              </p>
              <p>{t('doctorProfile.about.yearsOfExperience')}</p>
            </div>
          )}
          {languagesSpoken?.items && (
            <div className="mb-6">
              <p className="text-navy font-bold text-2xl">
                {getLanguages(languagesSpoken?.items)}
              </p>
              <p>{t('doctorProfile.about.languagesSpoken')}</p>
            </div>
          )}
        </div>
        <CV items={entry.cv?.items} />
      </div>
    </div>
  );
};

export default About;
